import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/timeoff_request_modal_actions';
import ReactModal from 'react-modal';
import { FieldRow } from 'common'; 
import { CFSingleSelect } from 'select';
import { CFDateRangePicker } from 'datePicker';
import moment from 'moment-timezone';
import {RequestedHours} from './RequestedHours';
import { AlertModal } from 'AlertModal';
import { default as CancelRequestConfirmationModal } from './CancelRequestConfirmationModal'

export class TimeOffRequestModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            timeOffType:-1,		
            startDate: null,
            endDate: null,
            availableStart: moment(), 
            isDateDisabled: true,
            requestStartDate: null,
            requestEndDate: null,
            isDateRangePickerClosed: false,
            warningMessage: null,
            showModal: false,
            isSubmitDisabled: true,
            ptoAccured: 0,
            submitCompleted: false,
            reasonValue: null,
            requestID: 0, 
            isApproved: null,
            showConfirmationModal: false,
            confirmationModalMessage: null   
        }
        
        if(props.actions.fetchTimeOffTypeAction) {
            props.actions.fetchTimeOffTypeAction();   
        }
            
        if(props.actions.fetchUnavailabledDatesAction) {
            props.actions.fetchUnavailabledDatesAction({
                managementUnitID: this.props.User.managementUnitID,
                agentID: this.props.User.userID
            });
        }

        this.dateRangeChanged = this.dateRangeChanged.bind(this);   
        this.onDateRangeClose = this.onDateRangeClose.bind(this);    
        this.containsBlockedDates = this.containsBlockedDates.bind(this)     
        this.isNoPtoBalance = this.isNoPtoBalance.bind(this)
        this.hideModalEvent = this.hideModalEvent.bind(this)
        this.hideCancelModalEvent = this.hideCancelModalEvent.bind(this)
        this.resetFormStates = this.resetFormStates.bind(this)
        this.submitTimeOffRequest = this.submitTimeOffRequest.bind(this)
        this.showConfirmationOfRequestResubmitModal = this.showConfirmationOfRequestResubmitModal.bind(this)
        this.reasonUpdated = this.reasonUpdated.bind(this)
        this.cancelTimeOffRequest = this.cancelTimeOffRequest.bind(this)
        this.loadRequestHours = this.loadRequestHours.bind(this)
        this.onConfirmationCancelClick = this.onConfirmationCancelClick.bind(this)
        this.isDateBetweenStartEndDate = this.isDateBetweenStartEndDate.bind(this)
        this.isUpdateNeededTimeOffRequest = this.isUpdateNeededTimeOffRequest.bind(this)
    }    

    componentWillReceiveProps(nextProps) {
        let _this = this
        if(nextProps.accuredProjections.length > 0 
            && this.state.timeOffType === 1            
            && nextProps.unavailableDates
            && nextProps.unavailableDates.length > 0
            && this.state.startDate !== null
            && this.state.endDate !== null){
            
            var timeOffAccured = nextProps.accuredProjections.find(function(element) {
                return element.timeoffType === _this.state.timeOffType
            })
       
            var validationResponse = this.validate(this.state.startDate, this.state.endDate, this.state.timeOffType, timeOffAccured.hoursAccrued)            
            
            this.setState({
                warningMessage: validationResponse.message,
                isSubmitDisabled: validationResponse.error 
                ? validationResponse.error 
                : !this.isUpdateNeededTimeOffRequest(),
                ptoAccured: timeOffAccured.hoursAccrued
            })            
        }

        if(this.props.TimeOffEnumItems.length !== nextProps.TimeOffEnumItems.length) {            
            var sickKey = nextProps.TimeOffEnumItems.find(function(obj) {
               return obj.value === "Sick"
            })

            this.setState({
                sickKey: sickKey.key
            })          
        }

        if(this.props.SummaryItems.length !== nextProps.SummaryItems.length 
            && this.state.sickKey > -1 ) {
            var sickAccured = nextProps.SummaryItems.find(function(obj) {
                return obj.type === _this.state.sickKey
            })

            this.setState({
                sickAccured: sickAccured.balance
            })
        }

        if (nextProps.timeOffResponse !== null 
            && !nextProps.timeOffResponse.error 
            && this.props.timeOffResponse !== nextProps.timeOffResponse)
        {
            this.hideModalEvent()
        }

        if(nextProps.timeOffResponse 
            && nextProps.timeOffResponse.error
            && this.props.timeOffResponse !== nextProps.timeOffResponse){
            this.setState({
                warningMessage: nextProps.timeOffResponse.responseText,
                isSubmitDisabled: nextProps.timeOffResponse.error
            })
        }

        if(nextProps.showModal !== this.props.showModal) {
            this.setState({
                showModal: nextProps.showModal,
                submitCompleted : false,
                isSubmitDisabled: true
            })
        }       

        let requestTimeOffBtnClicked = nextProps.timeOffRequest == null;

        if(this.props.timeOffRequest !== nextProps.timeOffRequest 
            && !requestTimeOffBtnClicked)
        {   
            this.props.actions.fetchUnavailabledDatesAction({
                managementUnitID: nextProps.User.managementUnitID,
                agentID: this.props.User.userID
            });                    
            this.setState({
                isEdit: true,
                timeOffType: parseInt(nextProps.timeOffRequest.timeoffType, 10),
                reasonValue: nextProps.timeOffRequest.timeoffReason,
                startDate: moment(nextProps.timeOffRequest.startDate),
                endDate: moment(nextProps.timeOffRequest.endDate),
                isSubmitDisabled: true
            })

            this.loadRequestHours(moment(nextProps.timeOffRequest.startDate), moment(nextProps.timeOffRequest.endDate), nextProps.timeOffRequest.timeoffType, nextProps.timeOffRequest.id);
            

        } else if (this.props.timeOffRequest === nextProps.timeOffRequest 
            && requestTimeOffBtnClicked) 
        {
            this.setState({ isEdit: false });
        }         
    }

 

    isUpdateNeededTimeOffRequest(){
        let timeOffRequest = this.props.timeOffRequest
        let {startDate, endDate, timeOffType, reasonValue, isEdit} = this.state
        
        if(isEdit && startDate && endDate){
            if(startDate.isSame(moment(timeOffRequest.startDate), 'day')
                && endDate.isSame(moment(timeOffRequest.endDate), 'day')
                && timeOffType === timeOffRequest.timeoffType
                && reasonValue === timeOffRequest.timeoffReason)
                    return false;
        }
        return true;
    }
    
    dateRangeChanged(startDate, endDate) {
		this.setState({ 
			startDate: startDate ? startDate : null, 
            endDate: endDate ? endDate : null,
            isDateRangePickerClosed: false          
		});
    }
    
    isDayBlocked(date) {   
        let unavailableDates = this.props.unavailableDates
        let agentTimeOffs = this.props.agentTimeOffsRequested

        if(this.state.timeOffType !== 0) {
            for(let i = 0; i < unavailableDates.length; i++) {
                if(date.isSame(unavailableDates[i], 'day')
                && !this.isDateBetweenStartEndDate(date)) {
                    return true;
                }
            }   
            return false;
        }
        else if(this.state.timeOffType === 0){ 
              
            for(let i = 0; i < agentTimeOffs.length; i++) {
                if(date.isSame(agentTimeOffs[i], 'day')
                && !this.isDateBetweenStartEndDate(date)) {
                    return true;
                }
            }   
            return false;            
        }
        return false
    }

    isDateBetweenStartEndDate(date){
        if(this.props.timeOffRequest && this.state.isEdit){
            if(date.isSameOrAfter(moment(this.props.timeOffRequest.startDate), 'day') 
            && date.isSameOrBefore(moment(this.props.timeOffRequest.endDate), 'day'))
                return true;
        }
        return false;
    }

    dropDownChange (event) {
        if(this.state.timeOffType !== event.target.value) {
            if(!this.state.isEdit) {
                this.resetFormStates(event.target.value);
            }

            if((event.target.value === "1"
                || event.target.value === "2")
                && this.props.actions.fetchUnavailabledDatesAction) {
                this.props.actions.fetchUnavailabledDatesAction({
                    managementUnitID: this.props.User.managementUnitID,
                    agentID: this.props.User.userID
                });
            }

            this.setState({
                warningMessage: null,
                isSubmitDisabled: false,
                timeOffType: parseInt(event.target.value, 10)
            })

            if(this.state.isEdit) {
                this.onDateRangeClose()
            }
        }
    }

    resetFormStates(timeOffType) {
        this.setState({
            timeOffType: parseInt(timeOffType,10),
            startDate: null,
            endDate: null,
            isDateRangePickerClosed: false,
            warningMessage: null,
            validationResponse: true,
            isSubmitDisabled: true,
            reasonValue: null  
        });
    }

    onDateRangeClose() {
        if(this.state.startDate !== null && this.state.endDate !== null) {
            this.loadRequestHours(this.state.startDate, this.state.endDate, this.state.timeOffType)   
        }
    }

    loadRequestHours(startDate, endDate, timeOffType, timeOffRequestID) {
        this.setState({ 
            requestStartDate: startDate ? startDate : null, 
            requestEndDate: endDate ? endDate : null,  
            isDateRangePickerClosed: true          
        });
        
        if(this.props.actions.fetchPTOBalanceAction && timeOffType === 1) {
            var filters ={}
            if(timeOffRequestID && timeOffRequestID > 0) {
                filters = {
                    agentID: this.props.User.userID,
                    requestStartDate: startDate.format('YYYY-MM-DD'),
                    timeOffId: timeOffRequestID
                }
            }
            else {
                filters = {
                    agentID: this.props.User.userID,
                    requestStartDate: startDate.format('YYYY-MM-DD'),
                    timeOffId: null
                }
            }
            
            this.props.actions.fetchPTOBalanceAction(filters);
        }

        if(timeOffType !== 1 ) {
            var validationResponse = this.validate(startDate, endDate, timeOffType, this.state.sickAccured)

            this.setState({
                warningMessage: validationResponse.message,
                isSubmitDisabled: validationResponse.error                                 
            }) 
        }
    }

    isNoPtoBalance(ptoAccured, startDate, endDate) {
        var ptoHours = (endDate.diff(startDate, 'days') + 1) * 8
        return   ptoHours >  ptoAccured     
    }

    containsBlockedDates(startDate, endDate) {
        for(let i = 0; i < this.props.unavailableDates.length; i++) {
            if(this.props.unavailableDates[i].isSameOrAfter(startDate, 'day') 
            && this.props.unavailableDates[i].isSameOrBefore(endDate, 'day')
            && !this.isDateBetweenStartEndDate(this.props.unavailableDates[i])) {
                return true;
            }
        }
        return false 
    }

    validate(startDate, endDate, timeOffType, ptoAccured) {
        if(timeOffType === 2) {
            if(this.containsBlockedDates(startDate, endDate)) {
                 return {
                    error: true,
                    message: errors.blocked_dates 
                }
            }
            else {
                return {
                    error: false,
                    message: warnings.vto_request
                }
            }
        }
        
        if(timeOffType === 1) {
            if(this.containsBlockedDates(startDate, endDate)) {
                 return {
                    error: true,
                    message: errors.blocked_dates 
                }
            }

            if(this.isNoPtoBalance(ptoAccured, startDate, endDate)) {
                return  {
                    error: false,
                    message: warnings.exceeeds_projected_accured
                }
            }
        }

        if(timeOffType === 0 && this.isNoPtoBalance(ptoAccured, startDate, endDate )) {
            return  {
                error: false,
                message: warnings.exceeeds_projected_accured
            }
        }

        return {
            error: false,
            message: null
        }
    }

    hideModalEvent() {
        this.resetFormStates(-1);
        this.props.toggleModal();
        this.setState({        
            showCancelModal: false,            
        })
    }

    hideCancelModalEvent() {
        this.setState({        
            showCancelModal: false,            
        })
    }

    submitTimeOffRequest() {
        var timeOff = {
           AgentId: this.props.User.userID,
           TimeoffType: this.state.timeOffType,
           StartDate: this.state.startDate.format(),
           EndDate: this.state.endDate.format(),
           TimeoffReason: this.state.reasonValue,
           TimeoffRequestId: this.state.isEdit ? this.props.timeOffRequest.id : 0
        }

        if(!this.state.isEdit){
            this.props.actions.requestTimeOffAction(timeOff)
        }
        else {
            this.props.actions.requestTimeOfUpdateAction(timeOff)
            this.setState({showConfirmationModal: false})
        }
    }

    showConfirmationOfRequestResubmitModal() {
        this.setState({
            showConfirmationModal: true,
            confirmationModalMessage: "Submitting edits will cancel the approved request and re-submit it for approval. Proceed?"
        })
    }

    onConfirmationCancelClick() {
        this.setState({
            showConfirmationModal: false,
            showCancelModal: false,
            confirmationModalMessage: null
        })
    }

    cancelTimeOffRequest() {  
        this.setState({            
            showCancelModal: true,            
        })
    }

    reasonUpdated(event) {
        this.setState({
            reasonValue: event.target.value,
            isSubmitDisabled:!this.isUpdateNeededTimeOffRequest(),          
        });
    }
    
    render() {
        var modalStyle = {width: '700px'};
        var overlayStyle = {zIndex: 9}     
        var options= this.props.timeoffType
        var isEditClass = this.state.isEdit ? '' : 'hide'
        var buttonText = this.state.isEdit? "Update" : "Request"
        let isStatusApproved = this.props.timeOffRequest !== null ? true : false;

        return(
            <div className="modal_wrapper"> 
            <ReactModal
                isOpen={this.state.showModal}
                requestID={this.props.requestID}
                style={{
                    content:modalStyle,
                    overlay: overlayStyle
                 }}
                ariaHideApp={false}             
                className='time_off_modal'>              

                <div className="edit-request-time-off-modal" >
                    <div className="modal_header">
                        Time Off Request 
                    </div>
                    <div className="modal_body">
                        <div className="message_block">
                        <button className={"cf-cancel right "+ isEditClass} type="button" onClick={this.cancelTimeOffRequest}>Cancel Request</button>                            
                        <span className="right">{this.state.warningMessage}</span>
                        </div>
                        <FieldRow>
                            <label className="label_text left">Type</label>
                            <span 
                                className="input_items">
                                <CFSingleSelect 
                                    className="time_off_type"
                                    options={options}
                                    onChangeEvent={(event) => this.dropDownChange(event)}
                                    value={this.state.timeOffType}
                                    />
                            </span>
                        </FieldRow>
                        <FieldRow>
                            <label className="label_text left">Dates</label>
                            <span 
                                className="input_items"> 
                               <CFDateRangePicker
                                    getDates={(startDate, endDate) => this.dateRangeChanged(startDate, endDate)}
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    availableStart={this.state.timeOffType === 0 ? null : this.state.availableStart}                                                                        
                                    isDayBlocked={(date) => this.isDayBlocked(date)}
                                    disabled={this.state.timeOffType >= 0 ? false : true}
                                    onClose={this.onDateRangeClose}
                                    availableEnd={moment().add(1, 'year')}
                                />
                            </span>
                        </FieldRow>
                        <FieldRow>
                            <RequestedHours 
                                requestStartDate={this.state.requestStartDate}
                                requestEndDate={this.state.requestEndDate}
                                isDateRangePickerClosed={this.state.isDateRangePickerClosed}
                                timeOffType={this.state.timeOffType}
                                beforePtotBalance={this.state.ptoAccured}

                            />
                        </FieldRow>
                        <FieldRow>
                            <label className="label_text left">Reason</label>
                            <span 
                                className="input_items">
                                <textarea className="input_reasons"  
                                    placeholder="100 character limit..."
                                    value={this.state.reasonValue || ''}
                                    onChange={this.reasonUpdated}/>                                
                                
                            </span>
                        </FieldRow>                        
                    </div>  
                    <div className="modal_footer cf">
                        <span className="footer button"> 
                            <span className="cancel_text" onClick={this.hideModalEvent}>Cancel </span>
                            <button className="cf-button cf-button-blue" type="button" disabled={this.state.isSubmitDisabled} onClick={isStatusApproved ? this.showConfirmationOfRequestResubmitModal : this.submitTimeOffRequest}>{buttonText}</button>
                        </span>
                    </div>
                        <AlertModal
                          className="export-confirmation-modal"
                          showModal={this.state.showConfirmationModal}
                          closeModal={() => this.setState({ showConfirmationModal: false })}
                          overlayClassName="save-error-modal-overlay"
                          height={133}
                          width={375}
                          acceptText="Yes"
                        >
                          <div className="alert-modal-content-cont">
                            <p className="alert-modal-header">Update Request</p>
                            <p className="alert-modal-content">
                              { this.state.confirmationModalMessage }
                            </p>
                        </div>
                        <div className="alert-modal-button-container">
                              <div 
                                className={this.props.isAcceptDisabled ? "alert-modal-button accept disabled" : "alert-modal-button accept"}
                                onClick={() => this.submitTimeOffRequest()}
                              >
                                Yes
                              </div>
                              <div 
                                className="alert-modal-button cancel"
                                onClick={() => this.onConfirmationCancelClick()}
                              >
                                  No
                              </div>
                        </div>

                        </AlertModal>
                </div>
            </ReactModal>
            {
                this.state.isEdit ?
                <CancelRequestConfirmationModal 
                    requestID={this.props.timeOffRequest !== null ? this.props.timeOffRequest.id : 0}
                    showModal={this.state.showCancelModal}
                    hideCancelModalEvent = {this.hideCancelModalEvent}
                    hideTimeOffModal = {this.hideModalEvent}/>
                :''
            }
            </div>
        )
    }
}

function mapStateToProps(state) {
	return {
        timeoffType: state.timeoff.timeoffType,
        unavailableDates: state.timeoff.unavailableDates,
        agentTimeOffsRequested: state.timeoff.agentTimeOffsRequested,
        accuredProjections: state.timeoff.accuredProjections,
        User: state.common.user,     
        timeOffResponse: state.timeoff.timeOffResponse,
        SummaryItems: state.timeoff.SummaryItems,
        TimeOffEnumItems: state.timeoff.TimeOffEnumItems  
    };
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TimeOffRequestModal);

let warnings = {
    exceeeds_projected_accured:  "Request exceeds projected accured hours. Request may be denied",
    vto_request: "VTO requests are approved based on supervisor's descretion. Request may be denied"
}

let errors = {
   blocked_dates: "Date(s) selected cannot be requested. Please submit available dates"
}


// WEBPACK FOOTER //
// ./src/features/timeoff/Modals/TimeOffRequestModal.js